import { render, staticRenderFns } from "./WeekMrpTab.vue?vue&type=template&id=765b5d20&"
import script from "./WeekMrpTab.vue?vue&type=script&lang=js&"
export * from "./WeekMrpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports